import { createTheme } from '@mantou/gem/helper/theme';

export const theme = createTheme({
  fontSize: '14px',
  fontFamily: 'Source Sans Pro,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif',
  primaryColor: '#bfbfbf',
  secondaryColor: '#939393',
  focusColor: '#3392d9',
  borderColor: '#333',
  backgroundColor: '#222222',
  darkBackgroundColor: '#151515',
  windowGap: '4px',
  panelContentGap: '4px',
});

export type Theme = Partial<typeof theme>;
